import { Tooltip, Typography } from '@mui/material'

const styles = {
  toolTip: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}

const DataGridBlankLabel = (value: string) => {
  return (
    <Tooltip title={value}>
      <Typography sx={styles.toolTip}>{value ? value : '-'}</Typography>
    </Tooltip>
  )
}

export default DataGridBlankLabel
